import type { z } from 'zod'
import type { eventCallbacksSchema } from '../config/agent-settings.validation.config'

// Infer types from the existing Zod schemas
type EventCallbacks = z.infer<typeof eventCallbacksSchema>

// Helper function to filter out empty event callbacks
export const filterEmptyEventCallbacks = (
  eventCallbacks: EventCallbacks | undefined,
): EventCallbacks | undefined => {
  if (!eventCallbacks) return {} as EventCallbacks

  const filtered: EventCallbacks = {} as EventCallbacks

  if (eventCallbacks.HANGUP?.url?.trim()) {
    filtered.HANGUP = eventCallbacks.HANGUP
  }

  if (eventCallbacks.RECORDING?.url?.trim()) {
    filtered.RECORDING = eventCallbacks.RECORDING
  }

  if (eventCallbacks.ERROR?.url?.trim()) {
    filtered.ERROR = eventCallbacks.ERROR
  }

  if (eventCallbacks.SMS_STATUS?.url?.trim()) {
    filtered.SMS_STATUS = eventCallbacks.SMS_STATUS
  }

  if (eventCallbacks.WHATSAPP_STATUS?.url?.trim()) {
    filtered.WHATSAPP_STATUS = eventCallbacks.WHATSAPP_STATUS
  }

  if (eventCallbacks.CONVERSATION_CLOSURE?.url?.trim()) {
    filtered.CONVERSATION_CLOSURE = eventCallbacks.CONVERSATION_CLOSURE
  }

  return Object.keys(filtered).length > 0 ? filtered : ({} as EventCallbacks)
}
